import { NormalizedNumber, Percentage } from '@sparkdotfi/common-universal'

import { darkenColor, getPalletteColor } from '../../common/chart-utils'
import { LiquidityChartComponentProps } from '../types'
import { mapProtocolToLabel } from '../utils'
import { formatPercentage } from '@/domain/common/format'
import { USD_MOCK_TOKEN } from '@/domain/types/Token'
import { cn } from '@/ui/utils/style'

export function LiquidityLineChart({
  items,
  highlightedIndex,
  setHighlightedIndex,
  className,
}: LiquidityChartComponentProps) {
  const totalAmount = items.reduce((acc, item) => acc.plus(item.amount), NormalizedNumber.ZERO)
  if (totalAmount.eq(NormalizedNumber.ZERO)) {
    return null
  }

  const displayedItems = items.filter((item) => item.amount.gt(NormalizedNumber.ZERO))

  return (
    <div className={cn('w-full px-1 sm:px-0', className)}>
      {displayedItems.map((item, index) => {
        const percentage = Percentage(item.amount.div(totalAmount))
        const color = highlightedIndex === index ? darkenColor(getPalletteColor(index)) : getPalletteColor(index)
        return (
          <div
            key={index}
            className={cn(
              'flex flex-col gap-2.5 py-2.5 first:pt-0 last:pb-0',
              highlightedIndex === index && 'cursor-pointer',
            )}
            onMouseEnter={() => setHighlightedIndex(index)}
            onMouseLeave={() => setHighlightedIndex(undefined)}
          >
            <div className="grid grid-cols-[1fr_auto_auto] items-baseline gap-1.5">
              <div className="flex items-center gap-1.5">
                <div className="size-1.5 rounded-full" style={{ backgroundColor: color }} />
                <div
                  className={cn('typography-label-3 transition-colors', highlightedIndex === index && 'text-secondary')}
                >
                  {mapProtocolToLabel(item.protocol)}
                </div>
              </div>
              <div
                className={cn(
                  'typography-label-3 text-right transition-colors',
                  highlightedIndex === index && 'text-secondary',
                )}
              >
                {formatPercentage(percentage)}
              </div>
              <div
                className={cn(
                  'typography-body-4 text-right text-secondary transition-colors',
                  highlightedIndex === index && 'text-primary',
                )}
              >
                ({USD_MOCK_TOKEN.formatUSD(item.amount, { compact: true })})
              </div>
            </div>
            <div className="relative h-px w-full overflow-hidden rounded-full bg-tertiary">
              <div
                className="absolute top-0 left-0 h-full w-full rounded-full"
                style={{ width: `${percentage.toNumber() * 100}%`, backgroundColor: color }}
              />
            </div>
          </div>
        )
      })}
    </div>
  )
}
